module.exports = __webpack_public_path__ + "img/zcgy-banner.9c793f99.jpg";